import { LeftLaurelLeaf } from "./left-laurel-leaf.component";
import { RightLaurelLeaf } from "./right-laurel-leaf.component";

type RatingWithLaurelProps = {
	rating: number;
	size?: "xs" | "xs-mobile" | "sm" | "md";
	className?: string;
};

const sizeConfig = {
	xs: {
		gap: "gap-0.5",
		varsClass:
			"[--laurel-font-size:14px] [--laurel-font-weight:700] [--laurel-color:var(--color-gray-700)] [--laurel-line-height:19.6px] [--laurel-leaf-width:8px] [--laurel-leaf-height:16px]",
	},
	"xs-mobile": {
		gap: "gap-0.5",
		varsClass:
			"[--laurel-font-size:12px] [--laurel-font-weight:700] [--laurel-color:var(--color-gray-700)] [--laurel-line-height:16.8px] [--laurel-leaf-width:7px] [--laurel-leaf-height:14px]",
	},
	sm: {
		gap: "gap-1",
		varsClass:
			"[--laurel-font-size:18px] [--laurel-font-weight:700] [--laurel-color:var(--color-gray-700)] [--laurel-line-height:normal] [--laurel-leaf-width:15px] [--laurel-leaf-height:30px]",
	},
	md: {
		gap: "gap-2",
		varsClass:
			"[--laurel-font-size:34px] [--laurel-font-weight:700] [--laurel-color:#374151] [--laurel-line-height:normal] [--laurel-leaf-width:25px] [--laurel-leaf-height:49px]",
	},
};

export function RatingWithLaurel({
	rating,
	size = "md",
	className,
}: RatingWithLaurelProps) {
	const config = sizeConfig[size];

	return (
		<div
			className={`flex items-center ${config.gap} ${config.varsClass} ${className ?? ""}`}
		>
			<LeftLaurelLeaf
				width="var(--laurel-leaf-width)"
				height="var(--laurel-leaf-height)"
				size={size}
			/>
			<div className="[font-size:var(--laurel-font-size)] [font-weight:var(--laurel-font-weight)] [color:var(--laurel-color)] [line-height:var(--laurel-line-height)]">
				{rating.toFixed(1)}
			</div>
			<RightLaurelLeaf
				width="var(--laurel-leaf-width)"
				height="var(--laurel-leaf-height)"
				size={size}
			/>
		</div>
	);
}
